import { MutationTree } from 'vuex'
import { PermissionState } from './state'
import { PermissionMutationType } from './mutation-types'
import { RouteRecordRaw } from 'vue-router'
import { constantRoutes } from '@/router'

export type Mutations<S = PermissionState> = {
    [PermissionMutationType.SET_ROUTES](state: S, routes: RouteRecordRaw[]): void
    [PermissionMutationType.SET_ROUTES_BAK](state: S, routes: any): void
    [PermissionMutationType.SET_WHITE_PATHS](state: S, paths: any): void
    [PermissionMutationType.SET_ACTIVE_ROUTE](state: S, route: string): void
}

export const mutations: MutationTree<PermissionState> & Mutations = {
    [PermissionMutationType.SET_ROUTES](state: PermissionState, routes: RouteRecordRaw[]) {
        state.routes = constantRoutes.concat(routes)
        // state.dynamicRoutes = routes
    },
    [PermissionMutationType.SET_ROUTES_BAK](state: PermissionState, routes: any) {
        // state.routes = constantRoutes.concat(routes)
        state.dynamicRoutes = JSON.stringify(routes)
        localStorage.setItem('dynamicRoutes', JSON.stringify(routes))
    },
    [PermissionMutationType.SET_WHITE_PATHS](state: PermissionState, paths: any) {
        state.whitePaths = paths
    },
    [PermissionMutationType.SET_ACTIVE_ROUTE](state: PermissionState, route: any) {
        state.activeRoute = route
    }
}